module.exports = __webpack_public_path__ + "static/media/美術教科展示.347081b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/exhibition/美術教科展示.png
// module id = 322
// module chunks = 10